import React from 'react';

import Generic from '../../layouts/Generic';
import { Grid, Cell } from '../../components/layout';

const HowToUse = () => {
  return (
    <Generic>
      <div className="l-section l-section--pt-0">
        <Grid>
          <Cell size={{ desktop: '12', tablet: '12', phone: '12' }}>
            <h1>How To Use</h1>
            <p>Welcome to our Budget Simulator, the People's Budget! Like other councils, we're dealing with financial challenges to maintain our services. Our budget is limited, as costs rise and reduced funding, it's tough to cover everything.</p>

            <p>We need your help to balance the budget. Which services do you value most? What should we protect or cut back on? Our simulator makes it easy to reduce spending in different areas and see the impact of your choices.</p>

            <p>Your input helps us make smarter decisions and create a balanced budget for the city. Your comments tell us what's important as we legally decide on the budget.</p>

            <p>Here's how you can contribute to this collective effort using the budget simulator:</p>
            <ul>
              <li>Generating Income: You can increase council tax and adjust charges in areas like parking, property, assets, and fees to generate more revenue.</li>
              <li>Adjusting Spending: Explore reducing spending in service areas, but be aware: each cut triggers consequences, highlighted by budget alerts. For deeper insights, click on the information icon.</li>
              <li>Overcoming Challenges: If making necessary cuts proves difficult, you have the option to ‘Give up’. We'd appreciate hearing more about your decision and any areas you feel should take priority.</li>
              <li>Successful Strategy: Congratulations on achieving your savings target! Submit your budget and share the reasoning behind your choices.</li>
            </ul>
            <p>Remember, the budget simulator aggregates everyone's budgets to create the People’s Budget. Thank you for actively contributing to shaping our city’s future through this collaborative tool!</p>
            <div className="text-center">
              <a href="/set-your-budget" className="c-button">Take the Budget Challenge</a>
            </div>
          </Cell>
        </Grid>
      </div>
    </Generic>
  )
}

export default HowToUse;



// WEBPACK FOOTER //
// ./src/pages/how-to-use/HowToUse.jsx